import { Box, Card } from "@mui/material";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import localize from "../../../common/localize";
import FailureLabel from "../../../components/common/FailureLabel";
import SuccessLabel from "../../../components/common/SuccessLabel";

export default function VehicleMovementItem({ assignment }) {
  return (
    <Card variant="outlined" className="flex justify-between gap-2 w-full p-2">
      <Box className="flex flex-col gap-2 w-full">
        <PageTitleSubtitle
          useEventTitleStyle
          useFieldTitleStyle
          title={
            !assignment.AssignedTo
              ? localize.unassigned
              : `${assignment.AssignedTo.SurName} ${assignment.AssignedTo.LastName}`
          }
          subtitle={
            !assignment.AssignedTo
              ? undefined
              : `${localize.identification}: ${assignment.AssignedTo?.Identification}`
          }
        />

        <label className="text-xs disabled">
          {new Date(assignment.CreationDate).toLocaleString(undefined, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })}
        </label>
      </Box>

      <Box className="flex" sx={{ width: "200px" }}>
        {!assignment.AssignedTo ? (
          <FailureLabel text={localize.unassigned} />
        ) : (
          <SuccessLabel text={localize.assigned} />
        )}
      </Box>
    </Card>
  );
}
